export default angular.module('eventix.common.directives.datePickers.dateRangePicker', [])
    .directive('daterangepicker', function($translate, $parse) {
        /**
         * @ngdoc directive
         * @name eventix.common.directives:daterangepicker
         * @restrict attribute
         * @description
         * Proxy-directive for initializing dangrossman/bootstrap-daterangepicker
         *
         * @example
         * <pre>
         * <input daterangepicker start="vm.start" end="vm.end" date-format="D-M-YY" options="{}" />
         * </pre>
         *
         * @param {Object} options Configuration object for DRP (optional)
         * @param {String} start Model attribute for the start date
         * @param {String} end Model attribute for the end date
         * @param {Boolean} [stringify=true] Save to models as date string or Moment object
         * @param {String} dateFormat MomentJS format string for model, will default to 'YYYY-MM-DD'
         */
        return {
            restrict: 'A',
            link: function(scope, element, attr) {
                let format = attr.dateFormat || 'YYYY-MM-DD';
                let start = scope.$eval(attr.start) || '2014-01-01';
                let end = scope.$eval(attr.end) || moment().format(format);
                let stringify = scope.$eval(attr.stringify);

                if (stringify === undefined) stringify = true;

                scope.$watch(() => scope.$eval(attr.start), s => {
                    if (!s) return;

                    s = moment(s, format);

                    if (s.isSame(moment(start, format), 'day')) return;

                    $(element).data('daterangepicker').setStartDate(s);
                });

                scope.$watch(() => scope.$eval(attr.end), e => {
                    if (!e) return;

                    e = moment(e, format);

                    if (e.isSame(moment(end, format), 'day')) return;

                    $(element).data('daterangepicker').setEndDate(e);
                });

                let defaults = {
                    format: 'DD-MM-YYYY',
                    startDate: moment(start, format),
                    endDate: moment(end, format),
                    opens: 'right',
                    drops: 'down',
                    ranges: {},
                    locale: {
                        /* eslint-disable */
                        applyLabel: $translate.instant('common.action.save'),
                        cancelLabel: $translate.instant('common.action.cancel'),
                        fromLabel: $translate.instant('common.datetime.from'),
                        toLabel: $translate.instant('common.datetime.until'),
                        customRangeLabel: $translate.instant('common.datetime.customRange'),
                        daysOfWeek: $translate.instant('common.datetime.days').split('_'),
                        monthNames: $translate.instant('common.datetime.months').split('_')
                        /* eslint-enable */
                    }
                };

                let left = moment().startOf('day');
                let right = moment().add(1, 'day').endOf('day');

                defaults.ranges[$translate.instant('common.datetime.today')] = [left.clone(), right.clone()];
                defaults.ranges[$translate.instant('common.datetime.lastWeek')] = [left.clone().subtract(1, 'week'), right.clone()];
                defaults.ranges[$translate.instant('common.datetime.lastMonth')] = [left.clone().subtract(1, 'month'), right.clone()];
                defaults.ranges[$translate.instant('common.datetime.lastHalfYear')] = [left.clone().subtract(6, 'months'), right.clone()];
                defaults.ranges[$translate.instant('common.datetime.allTime')] = [moment('01-01-2014', 'DD-MM-YYYY'), right.clone()];

                let options = _.defaultsDeep(scope.$eval(attr.options) || {}, defaults);

                $(element).css('cursor', 'pointer').daterangepicker(options, callback);

                function callback(s, e) {
                    let model;
                    start = s;
                    end = e;

                    model = $parse(attr.start);
                    model.assign(scope, stringify ? s.format(format) : s);

                    model = $parse(attr.end);
                    model.assign(scope, stringify ? e.format(format) : e);

                    if (!stringify) scope.$apply();
                }
            }
        };
    }).name;
